import { Question } from "./QuestionTypes"

// check for non-alphabetical choices
// x.filter(
// 	i =>
// 		i.choices &&
// 		i.choices.map(i => i.option).join(",") !==
// 			i.choices
// 				.map(i => i.option)
// 				.sort()
// 				.join(",")
// )

export const questions: Question[][] = [
	[
		{
			category: "world",
			challenge: "When was the first crusade?",
			choices: [
				{ option: "887-901" },
				{ option: "990-1072" },
				{ option: "1096-1099", correct: true },
				{ option: "1223-1236" },
			],
			content: "first-crusade.jpg",
			citation: "https://en.wikipedia.org/wiki/First_Crusade",
		},
		{
			category: "science",
			challenge: "Which molecule has the fewest atoms?",
			choices: [
				{ option: "Butane" },
				{ option: "Ethane" },
				{ option: "Methane", correct: true },
				{ option: "Propane" },
			],
			reveal: "methane.png",
		},
		{
			category: "life",
			challenge: "Which type of tree has needles that typically bear in groups?",
			choices: [{ option: "Cedar" }, { option: "Fir" }, { option: "Pine", correct: true }, { option: "Spruce" }],
			content: "pine.jpg",
			citation: "https://www.finegardening.com/article/fir-vs-spruce-vs-pine-how-to-tell-them-apart",
		},
		{
			category: "world",
			challenge: "Which country touches the equator?",
			choices: [
				{ option: "Kenya", correct: true },
				{ option: "Malaysia" },
				{ option: "Nigeria" },
				{ option: "Peru" },
			],
			reveal: "kenya-map.svg",
		},
		// {category:"science", challenge:"Which of these lines is hyperbolic?", }
		{
			category: "national",
			challenge: "Which winery is based in British Columbia?",
			choices: [
				{ option: "Chateau Montelena" },
				{ option: "Columbia Crest" },
				{ option: "Mission Hill", correct: true },
				{ option: "Holden Manz" },
			],
			reveal: "missionhill.png",
		},
		{
			category: "tech",
			challenge: "Which app isn't part of Apple's iWork suite?",
			choices: [
				{ option: "Pages" },
				{ option: "Numbers" },
				{ option: "Keynote" },
				{ option: "Impressions", correct: true },
			],
			reveal: "iwork.webp",
		},
		{
			category: "film",
			challenge: "Which isn't an ongoing Star Trek TV ?",
			choices: [
				{ option: "Discovery" },
				{ option: "Insurrection", correct: true },
				{ option: "Lower Decks" },
				{ option: "Picard" },
			],
			reveal: "startrek.jpg",
		},
		{
			category: "life",
			challenge: "Which animal has the longest average lifespan?",
			choices: [
				{ option: "Sea cucumber", data: 10 },
				{ option: "Sea lion", data: 30 },
				{ option: "Sea urchin", data: 200, correct: true },
				{ option: "Seahorse", data: 5 },
			],
			reveal: "sea-urchin.jpg",
			citation:
				"https://today.oregonstate.edu/archives/2003/nov/red-sea-urchins-discovered-be-one-earths-oldest-animals#:~:text=CORVALLIS%2C%20Ore.,with%20few%20signs%20of%20age.",
			// citation: "https://www.nwf.org/Educational-Resources/Wildlife-Guide/Invertebrates/Sea-Cucumbers#:~:text=A%20sea%20cucumber%20can%20live,Sea%20cucumber%20populations%20are%20stable.",
			// citation: "https://en.wikipedia.org/wiki/Sea_lion",
			// citation: "https://a-z-animals.com/blog/the-worlds-oldest-sea-turtle/",
			// citation: "https://projectseahorse.org/saving-seahorses/seahorse-faqs/#:~:text=How%20long%20do%20they%20live,years%20for%20the%20larger%20species.",
		},
		{
			category: "world",
			challenge: "Name these cities ordered from A to D",
			choices: [
				{ option: "Dnipro, Kyiv, Kharhiv, Odessa" },
				{ option: "Kharkiv, Dnipro, Odessa, Kyiv" },
				{ option: "Kharkiv, Odessa, Kyiv, Dnipro" },
				{ option: "Kyiv, Kharkiv, Dnipro, Odessa", correct: true },
			],
			content: "ukraine-map.svg",
		},
		{
			category: "health",
			challenge: "According to the NFPA 704 standard for SDS, which colour zone represents chemical instability?",
			choices: [{ option: "Red" }, { option: "Blue" }, { option: "Yellow", correct: true }, { option: "White" }],
			content: "NFPA_704.svg",
			reveal: "nfpa-reveal.png",
			citation: "https://www.nfpa.org/Assets/files/AboutTheCodes/704/704_FAQs.pdf",
		},
		{
			category: "world",
			challenge: "Which country is NOT a member of the Schengen area?",
			choices: [
				{ option: "Finland" },
				{ option: "Poland" },
				{ option: "Switzerland" },
				{ option: "United Kingdom", correct: true },
			],
			reveal: "schengen.svg",
		},
		{
			category: "world",
			challenge: "Which WWII leader was alive most recently?",
			choices: [
				{ option: "Churchill" },
				{ option: "Hirohito", correct: true },
				{ option: "Roosevelt" },
				{ option: "Stalin" },
			],
			reveal: "hirohito.jpg",
		},
		{
			category: "literature",
			challenge: 'What does the word "conurbation" mean?',
			choices: [
				{ option: "Coalescing municipalities", correct: true },
				{ option: "A Keith Urban concert" },
				{ option: "Paradise, as opposed to tarnation" },
				{ option: "Psychological consequences fo high density habitation" },
			],
			citation: "https://en.wikipedia.org/wiki/Conurbation",
			reveal: "lower-mainland.jpg",
		},
		{
			category: "industry",
			challenge: "What fighter jet has Canada recently announced its intention to purchase 88 of?",
			choices: [
				{ option: "Eurofighter Typhoon" },
				{ option: "Lockheed Martin F-22" },
				{ option: "Lockheed Martin F-35", correct: true },
				{ option: "Saab JAS 39 Gripen" },
			],
			reveal: "f35.jpg",
			// answer: "Lockheed Martin F-35",
		},
		{
			category: "games",
			challenge: "In what year did the Canucks first debut an orca-themed logo?",
			choices: [{ option: "1995" }, { option: "1997", correct: true }, { option: "1999" }, { option: "2001" }],
			reveal: "canucks-logos.jpg",
			citation: "https://1000logos.net/vancouver-canucks-logo/",
			content: "canucks-orca.png",
		},
		// {
		// 	category: "industry",
		// 	challenge: "Which screw size has a larger shank diameter?",
		// 	choices: [
		// 		{ option: "#4", data: 2.8448 },
		// 		{ option: "#6", data: 3.5052 },
		// 		{ option: "M5", data: 5 },
		// 		{ option: "M8", data: 8, correct: true },
		// 	],
		// 	reveal: "screws.png",
		// },
		{
			category: "industry",
			challenge: "Which is longer?",
			choices: [
				{ option: "Furlong", data: 1 },
				{ option: "League", correct: true, data: 8 * 3 },
				{ option: "Mile", data: 8 },
				{ option: "Nautical mile", data: 8 * 1.1508 },
			],
		},
		{
			category: "life",
			challenge: "Which adult male has more mass?",
			choices: [
				{ option: "American bison", data: 1270 },
				{ option: "Clydesdale", data: 1000 },
				{ option: "Giraffe", data: 1192 },
				{ option: "Hippopotamus", data: 1500, correct: true },
			],
			reveal: "hippo.jpg",
			citation: "https://en.wikipedia.org/wiki/Hippopotamus",
		},
		// {category:"puzzle", challenge: "The odds of winning the 6/49 lottery are 1 in...", choices: [{option:"49^6"}, {option:"49!/6!"}, {option:"49!/(49-6)!"}, {option: "49!/6!(49-6)!"}]}
		// {
		// 	category: "puzzle",
		// 	challenge: "The odds of any given 5-dice roll being a Yahtzee are 1 in...",
		// 	choices: [{ option: "5^6" }, { option: "6^4", correct: true }, { option: "6^5" }, { option: "5!" }],
		// 	reveal: "yahtzee.png",
		// },
		{
			category: "science",
			challenge: "Which formula produces a circle?",
			choices: [
				{ option: "y = log2(x)" },
				{ option: "y = x^3 + x^2 + x" },
				{ option: "x^2 + y^2 = 2^2", correct: true },
				{ option: "2x^2 = y^0.5" },
			],
			reveal: "circle.png",
		},
		{
			category: "industry",
			challenge: "Which is the most valuable company in China by market cap?",
			choices: [
				{ option: "Alibaba", data: 292_400_000_000 },
				{ option: "ICBC", data: 254_590_000_000 },
				{ option: "PetroChina", data: 144_110_000_000 },
				{ option: "Tencent", correct: true, data: 448_900_000_000 },
			],
			reveal: "tencent.jpg",
		},
		{
			category: "local",
			challenge: "How long is the Skeena River?",
			choices: [
				{ option: "570 km", correct: true },
				{ option: "810 km" },
				{ option: "1117 km" },
				{ option: "1450 km" },
			],
			reveal: "skeena.png",
		},
	],
	[
		{
			category: "tech",
			challenge: "What is Apple's latest desktop CPU series called?",
			answer: "M1 (Pro|Max|Ultra)",
			reveal: "m1-3.jpg",
			content: "m1.png",
		},
		{
			category: "industry",
			challenge: "According to the EPA, how many litres is a standard toilet flush (rounded)?",
			answer: 7,
			citation: "https://www.epa.gov/watersense/residential-toilets",
		},
		{
			category: "health",
			challenge: "How many mg of caffeine is in a tall (354ml) Starbucks coffee, ± 30?",
			answer: 235,
			tolerance: 30,
			content: "starbucks.jpg",
			citation: "https://www.starbucks.ca/menu/product/480/hot/nutrition",
		},
		{
			category: "world",
			challenge: "What is the official language of Malaysia?",
			answer: "Malaysian",
			content: "malaysia.svg",
			citation: "https://en.wikipedia.org/wiki/Malaysia",
		},
		{
			category: "puzzle",
			challenge: "In sudoku, what number goes here?",
			content: "sudoku-question.svg",
			reveal: "sudoku-answer.svg",
			answer: "3",
			notransition: true,
			citation: "https://en.wikipedia.org/wiki/Sudoku",
		},
		{
			category: "world",
			challenge: "Which country was awarded the most medals at the 2022 Winter Olympics?",
			answer: "Norway",
			citation: "https://en.wikipedia.org/wiki/2022_Winter_Olympics",
			reveal: "norway.svg",
		},
		{
			category: "film",
			challenge: "What is Will Smith's wife's name?",
			answer: "Jada Smith",
			content: "will-jada-smith.webp",
		},
		{
			category: "economics",
			challenge: "What does the digital certificate of ownership technology known as NFT stand for?",
			answer: "Non-Fungible Token",
			content: "nft.jpg",
		},
		{
			category: "industry",
			challenge: "What Boeing model number is known as the Dreamliner?",
			answer: "787",
			content: "dreamliner.jpg",
			reveal: "dreamliner.png",
		},
		{
			category: "world",
			challenge: "Name one of the typically recognized Baltic countries",
			answer: "Estonia, Latvia, Lithuania",
			reveal: "baltics.png",
		},
		{
			category: "world",
			challenge: "Which Russian leader presided over the fall of the USSR?",
			answer: "Mikhail Gorbachev",
			reveal: "gorbachev.jpg",
		},
		{
			category: "economics",
			challenge: "What is the minimum wage in British Columbia?",
			answer: "$15.20/hr",
			citation: "https://news.gov.bc.ca/releases/2022LBR0003-000337",
		},
		{
			category: "national",
			challenge: "What river flows through Saskatoon?",
			answer: "South Saskatchewan River",
			content: "saskatchewan-river.jpg",
		},
		{
			category: "local",
			challenge:
				"How many avenues lie between Lakelse Avenue and McConnel Avenue in the 4700 block of Terrace? (exclusive)",
			answer: "11: Lazelle, Park, Davis, Walsh, Loen, Olson, Scott, Straume, Hamer, Soucie, Tuck",
			reveal: "terrace-roads.png",
		},
		{
			category: "literature",
			challenge: "Who wrote The Hitchhiker's Guide to the Galaxy",
			content: "hitchhikers-guide.jpg",
			reveal: "douglas-adams.jpg",
			answer: "Douglas Adams",
		},
		{ category: "health", challenge: "What does the food additive MSG stand for?", answer: "Monosodium Glutamate" },
		{
			category: "science",
			challenge: "Name the next digit of pi: 3.1415",
			answer: Math.PI,
			content: "pi.gif",
		},
		{ category: "games", challenge: "Name this character", answer: "Samus Aran", content: "samus.png" },
		{
			category: "literature",
			challenge: "What is this meme commonly called?",
			answer: "Bad Luck Brian",
			reveal: "blb-reveal.jpg",
			content: "blb.jpg",
			notransition: true,
			citation: "https://en.wikipedia.org/wiki/Bad_Luck_Brian",
		},
		{
			category: "literature",
			challenge: "What is TED's slogan?",
			content: "ted.svg",
			reveal: "ted.mp4",
			answer: "Ideas worth spreading",
			// autoplay: true,
		},
	],
	[
		{
			category: "music",
			challenge: "Name the song",
			answer: "Born to Die (Lana Del Rey)",
			content: "born-to-die.mp4",
			reveal: "born-to-die-a.mp4",
			fullscreen: true,
		},
		{
			category: "film",
			challenge: "Name the actor",
			answer: "Russell Crowe",
			content: "beautiful-mind.mp4",
			reveal: "russell-crowe.jpg",
			fullscreen: true,
		},
		{
			category: "film",
			challenge: "Name the movie",
			answer: "Blood Diamond",
			content: "blood-diamond.mp4",
			reveal: "blood-diamond.jpg",
			fullscreen: true,
		},
		// {
		// 	category: "film",
		// 	challenge: "Name the TV series",
		// 	answer: "Bridgerton",
		// 	content: "bridgerton.mp4",
		// 	reveal: "bridgerton.jpg",
		// 	fullscreen: true,
		// },
		{ category: "film", challenge: "Name the movie", answer: "CODA", content: "coda.mp4", reveal: "coda.jpg" },
		{
			category: "music",
			challenge: "Name the song",
			answer: "Ex's & Oh's (Elle King)",
			content: "exes-ohs.mp4",
			reveal: "exes-ohs-2.mp4",
			fullscreen: true,
		},
		{
			category: "music",
			challenge: "Name the artist",
			answer: "Machine Gun Kelly (Colson Baker)",
			content: "machine-gun-kelly.mp4",
			reveal: "mgk.mp4",
			fullscreen: true,
		},
		{
			category: "film",
			challenge: "Name the TV show",
			answer: "Parks and Recreation",
			content: "parcs-rec.mp4",
			reveal: "parcs-rec.jpg",
			fullscreen: true,
		},
		{
			category: "film",
			challenge: "Name the artist",
			answer: "Rita MacNeil",
			content: "rita-macneil.mp4",
			reveal: "rita-macneil.jpg",
			fullscreen: true,
		},
		{
			category: "film",
			challenge: "Name the actor",
			answer: "Simu Liu (刘思慕)",
			content: "shang-chi.mp4",
			reveal: "simu-liu.jpg",
			fullscreen: true,
		},
		{
			category: "music",
			challenge: "Name the song",
			answer: "Cardigan",
			content: "cardigan.mp4",
			reveal: "cardigan-a.mp4",
			fullscreen: true,
		},
		{
			category: "music",
			challenge: "Name the band",
			answer: "The Cardigans",
			content: "the-cardigans.mp4",
			reveal: "the-cardigans.jpg",
			fullscreen: true,
		},
		{
			category: "music",
			challenge: "Name the movie (full title)",
			answer: "Top Gun: Maverick",
			content: "maverick.mp4",
			reveal: "maverick.jpg",
			fullscreen: true,
		},
		{
			category: "music",
			challenge: "Name the band (entire name!)",
			answer: "King Crow and the Ladies from Hell",
			content: "in-the-ground.mp4",
			reveal: "king-crow.webp",
			fullscreen: true,
		},
		{
			category: "film",
			challenge: "Name the movie",
			answer: "The Martian",
			content: "the-martian.mp4",
			reveal: "martian.webp",
			fullscreen: true,
		},
		{
			category: "music",
			challenge: "Name the movie",
			answer: "1917",
			content: "1917.mp4",
			reveal: "1917.jpg",
			fullscreen: true,
		},
		{
			category: "film",
			challenge: "What artificial Jeopardy contestant is referred to here?",
			answer: "Watson",
			content: "watson.mp4",
			reveal: "watson.webp",
			fullscreen: true,
		},
		{
			category: "film",
			challenge: "Name the characters: Lords ____ and ____",
			answer: "Varys, Baelish",
			content: "chaos.mp4",
			reveal: "chaos.jpg",
			fullscreen: true,
		},
		{
			category: "film",
			challenge: "Name this person",
			answer: "Julia Child",
			content: "julia-child.mp4",
			reveal: "julia-child.jpg",
			fullscreen: true,
		},
		{
			category: "world",
			challenge: "Name this military operation (not the whole war)",
			answer: "Operation Desert Storm",
			content: "gulf-war.mp4",
			reveal: "desert-storm.png",
			fullscreen: true,
		},
		{
			category: "film",
			challenge: "Name all four main characters",
			answer: "Carrie, Charlotte, Samantha, Miranda",
			content: "sex-city.mp4",
			reveal: "sex-city.jpg",
			fullscreen: true,
		},
	],
	// }, {
	// 	category: "tech",
	// 	challenge: "How would you limit a Google search to results from CNN?",
	// 	choices: [{option: "Include site:cnn.com in the search", correct: true}, {option: ""}]
	// }, {
	// 	category: "health",
	// 	challenge: "What doe sthe CFL plastic term mean?",
	// 	answer: ""
	// }
	// {
	// 	category: "world",
	// 	challenge: "Who is this (at least one name spelled exactly)?",
	// 	content: "zelenskyy.jpg",
	// 	answer: "Volodymyr Zelenskyy",
	// },
	// {
	// 	category: "national",
	// 	challenge: "Which is NOT a Canadian personal banking service?",
	// 	choices: [{ option: "Tangerine" }, { option: "EQ Bank" }, { option: "Simplii Financial" }, { option: "" }],
	// },
	// {
	// 	category: "world",
	// 	challenge: "Which country previously possessed nuclear weapons, and has relinquished them?",
	// 	choices: [
	// 		{ option: "Canada" },
	// 		{ option: "India" },
	// 		{ option: "Japan" },
	// 		{ option: "South Africa", correct: true },
	// 	],
	// },
]
// What is azov
// How would you limit google search results to cnn.com
// What does CFL stand for in plastics
// Name a year within Richard the Lionhearts life, ± 50
// Which is Ukraine’s crest symbol
// Name the show Don’t Look Up
// In what year did Russia invade Crimea
// What is the disputed Minsk agreement region? Donbas?
// What video game is this?  GRRM game
// What is not a Windows code name, Whistler Longhorn etc
// What was the property tax rate last year?
// What isn’t a Canadian bank, Tangerine, Simplyy…?
// Pick a year of the Kievan Rus empire
// Who is this?  Mkbhd.
// Who sings this?  Ex's and Oh's
// What song is this? Cardigan
// Who sang this?  The Cardigans
// What is this port called?  USB-C
// Who is this?  The Weeknd
// Average weight of a newborn baby boy?
// Nearest Legion branch?
// Who is this?  Machine Gun Kelly clip
// Who is this?  Rita McNeal
// What is a lye
// Straight to jail meme?
// Any other meme
// CBS All Access, other streaming service names
